import type {
  GetUserOutstandingBalanceOptions,
  GetUserPaymentsOptions,
} from 'api/payments'

const ROOT = 'userPayments'
const OUTSTANDING_BALANCE_ROOT = 'userOutstandingBalance'

export const paymentKeys = {
  list: [ROOT] as const,
  search: (filters?: GetUserPaymentsOptions) =>
    [ROOT, 'search', filters] as const,
  outstandingBalance: [OUTSTANDING_BALANCE_ROOT] as const,
  outstandingBalanceDetail: (
    userId?: GetUserOutstandingBalanceOptions['userId']
  ) => [OUTSTANDING_BALANCE_ROOT, userId?.toString()] as const,
}
